$(document).ready(function () {

    var $featuredProducts = $('.featured-products-slider-row .products');

    var imagesSlider = function($slider){

        $slider.slick({
            arrows: true,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 4,
            speed: 500,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 426,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });
    }


    if ($featuredProducts.length) {

        $featuredProducts.each(function(){
            imagesSlider($(this));
        })

        $(window).resize(function(){
            $featuredProducts.each(function(){
                if ($(this).hasClass('slick-initialized')) {
                    $(this).slick('resize');
                } else {
                    imagesSlider($(this));
                }

            })
        });
    }
});